<template>
  <artmisads-modal
    :open="open"
    :title="title"
    :width="520"
    :maskClosable="false"
    :footer="null"
    :onCancel="() => (open = false)"
    :destroyOnClose="true"
  >
    <bonusProgramInfoPopover v-if="open && programId"  :program-id="programId" />
  </artmisads-modal>
</template>

<script setup>
import { ref, defineExpose } from 'vue';
import bonusProgramInfoPopover from './bonusProgramInfoPopover.vue';
import { useUserInfoStore } from '~/storeData/index'
const store = useUserInfoStore()
const open = ref(false);
const programId = ref(null);
const title=ref('')
const show = (row) => {
  programId.value = row?.programId ?? row?.bonusProgramId;
  if(row.programId){
    title.value = 'Bonus Rule';
  }else{
    title.value = 'Bonus Program Info';
  }
  open.value = true;
};

defineExpose({ show });
</script>
